import useBaseMessangeAsyncSuccess from './useBaseMessageAsyncSuccess';
import useSnackbar from './useSnackbar';

function useSnackbarAsyncSuccess() {
  return useBaseMessangeAsyncSuccess({ hook: useSnackbar });
}

export default useSnackbarAsyncSuccess;
